import { render, staticRenderFns } from "./TransitionHouseholdValue.vue?vue&type=template&id=3d8a90bd&scoped=true"
import script from "./TransitionHouseholdValue.vue?vue&type=script&lang=js"
export * from "./TransitionHouseholdValue.vue?vue&type=script&lang=js"
import style0 from "./TransitionHouseholdValue.vue?vue&type=style&index=0&id=3d8a90bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8a90bd",
  null
  
)

export default component.exports